import React from 'react';
import Button from './Button';

export default function Modal({
  open,
  title,
  children,
  primaryLabel = 'Save',
  onPrimary,
  secondaryLabel = 'Cancel',
  onSecondary,
  primaryDisabled = false,
}) {
  if (!open) return null;

  return (
    <div className="ca-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="ca-modal-title">
      <div className="ca-confirm-modal__dialog">
        {title ? <p id="ca-modal-title" className="ca-confirm-modal__message">{title}</p> : null}
        {children}
        <div className="ca-confirm-modal__actions">
          <Button variant="outline" onClick={onSecondary}>{secondaryLabel}</Button>
          <Button onClick={onPrimary} disabled={primaryDisabled}>{primaryLabel}</Button>
        </div>
      </div>
    </div>
  );
}